import Purchase from './src/main'
export default {
  install(Vue, props) {
    Vue.prototype.$PurchaseModal = options => {
      Purchase(options, props)
    }
  }
}
